import React, { useState } from "react";

export default function FAQs() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Is registration required to use the Biodata Maker?",
      answer: "No, our Biodata Maker does not require any registration. You can start creating your biodata right away without any sign-up process."
    },
    {
      question: "How many templates are available to choose from?",
      answer: "We offer multiple beautifully designed templates to choose from. You can select the template that best suits your style and preferences for creating your biodata."
    },
    {
      question: "Is it possible to edit my biodata after creating it?",
      answer: "We prioritize user privacy and data security. By not storing any information, we ensure your data remains confidential. However, this means that once the biodata is downloaded, it cannot be modified."
    },
    {
      question: "How can I add new fields to my biodata?",
      answer: "With our biodata builder, adding new fields is simple. You can include additional sections or fields to accommodate specific information that are important to you."
    },
    {
      question: "Can I preview my customized biodata before finalizing it?",
      answer: "Yes, before generating the final biodata, you can preview your customized version to ensure everything looks as desired. This allows you to make any necessary adjustments before completing the process."
    },
    {
      question: "How can I reach out to you for queries or feedback?",
      answer: (
        <>
          We welcome your queries and feedback! You can easily get in touch with us by dropping an email at{" "}
          <a
            className="text-pink-500 hover:text-pink-600 font-semibold"
            href="mailto:supbiodatamaker@gmail.com"
          >
            supbiodatamaker@gmail.com
          </a>
          .
        </>
      )
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section 
      className="py-20 bg-white"
      aria-label="Frequently Asked Questions"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 abc-bold">
            Frequently Asked Questions
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto abc-regular">
            Find answers to common questions about our biodata maker platform
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden"
            >
              <button
                className="w-full px-6 py-6 text-left focus:outline-none focus:ring-4 focus:ring-pink-300 focus:ring-opacity-50"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-900 abc-semibold pr-4">
                    {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    <svg
                      className={`w-6 h-6 text-gray-500 transform transition-transform duration-300 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
              </button>
              
              <div
                id={`faq-answer-${index}`}
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-6">
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-gray-600 leading-relaxed abc-regular">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 text-center">
          <div className="bg-gradient-to-r from-pink-50 to-purple-50 rounded-2xl p-8 border border-pink-100">
            <h3 className="text-xl font-semibold text-gray-900 mb-4 abc-semibold">
              Still have questions?
            </h3>
            <p className="text-gray-600 mb-6 abc-regular">
              We're here to help! Reach out to us and we'll get back to you as soon as possible.
            </p>
            <a
              href="mailto:supbiodatamaker@gmail.com"
              className="inline-flex items-center px-6 py-3 text-white bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 rounded-full transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-pink-300 abc-semibold"
            >
              <span className="mr-2">📧</span>
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
